export const search = {
  search: "Search",
  searchTerm: "Search term"
};
